'use strict';

/**
* Copyright (c) 2020 Copyright bp All Rights Reserved.
* Author: lipengxiang
* Date: 2020-02-19 01:11
* Desc: 
*/

import html5History from './html5History';

export default (new html5History());